import React, {useEffect,useRef} from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useReactToPrint } from 'react-to-print';

import logo from '../assets/logo_patos.png';

export const DialogPrintEstacionamento = ({ visible, setVisible, estacionamento }) => {
    const cssText = `
    #print-content {
        font-family: 'Open Sans', sans-serif;
        width: 100%;
        text-align: center;

    }

    .contEstacionamento {
        width: 270px;
        height: 690px;
        border: 1px solid black;
    }

    .bordaCortar {
        width: 270px;
        border: 2px dashed #000;
        margin: 15px 0;
    }


    img {
            margin-top: 25px;
            width: 100%;
            max-width: 250px;
            height: auto;
            display: block;
        }

        .header-img {
            display: flex;
            justify-content: center;
        }

        .header {
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        .header h1 {
            font-weight: normal;
        }

        .texEstacionamento{
            line-heigth: normal;
            margin: 0px;
        }

        .texEstacionamento span {
            text-decoration: underline;
        }

        .header h2 {

            font-weight: normal
            margin-bottom: 0px;
        }

        .header h4 {
            margin-top: 20px;
        }
    `



    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef, pageStyle: cssText });

    const header = (
        <div>
            <Button label="Imprimir" className="p-button-secondary" icon="pi pi-print" onClick={reactToPrintFn} />
        </div>
    );


    useEffect(() => {


    }, [estacionamento])



    return (
        <Dialog
            visible={visible}
            onHide={() => setVisible(false)}
            header={header}
            className='p-scrollpanel-bar-y'
            breakpoints={{ '960px': '75vw', '640px': '100vw' }}
            style={{ width: '50vw', heigth: '5vw' }}
        >

                <div id="print-content" ref={contentRef}>

                {estacionamento.length > 0 ?

                    <div className="contEstacionamento" style={{'border': '1px solid black'}}>
                    <div className="p-d-flex p-ai-center p-flex-column header">

                        <h4>Ceasa Regional de Patos de Minas</h4>

                        <h3 className='texEstacionamento' style={{'lineHeigth': 'normal', 'margin': '0px'}}>ESTACIONAMENTO</h3>
                        <h3 className='texEstacionamento' style={{'lineHeigth': 'normal', 'margin': '0px'}}>COMPRADOR AVULSO</h3>
                        <br />

                        {/* <h3 className='texEstacionamento' style={{'lineHeigth': 'normal', 'margin': '0px'}}>Veículo </h3> */}
                        <h3 className='texEstacionamento' style={{'lineHeigth': 'normal', 'margin': '0px'}}>Veículo {estacionamento[0].veiculoTipo.nome}</h3>
                        <h3 className='texEstacionamento' style={{'lineHeigth': 'normal', 'margin': '0px'}}>{estacionamento[0].id}</h3>

                    </div>

                    <div className="bordaCortar" style={{'border': '1px dashed #000', 'margin': '15px 0 10px 0'}}></div>

                    <div className="p-d-flex p-ai-center p-flex-column header">
                        <h3 className='texEstacionamento' style={{'lineHeigth': 'normal', 'margin': '0px'}}>ESTACIONAMENTO</h3>
                        <h3 className='texEstacionamento' style={{'lineHeigth': 'normal', 'margin': '0px'}}>COMPRADOR</h3>
                    </div>

                    <div className="p-d-flex p-jc-center header-img">
                    <img style={{width:190, height:190}}
                            id="logo"
                            alt="Logo"
                            src={logo}
                        />
                    </div>

                    <div className="p-d-flex p-ai-center p-flex-column header">
                        {/* <h3>VEÍCULO </h3> */}
                        <h3>Veículo {estacionamento[0].veiculoTipo.nome}</h3>

                    </div>

                    <div className="p-d-flex p-ai-center p-flex-column header">
                        <h2 className='texEstacionamento' style={{'lineHeigth': 'normal', 'margin': '0px'}}><span>AVULSO</span></h2>
                        <h3 className='texEstacionamento' style={{'lineHeigth': 'normal', 'margin': '0px'}}>{estacionamento[0].id}</h3>
                    </div>
                    <br />

                    <div className="p-d-flex p-ai-center p-flex-column header">
                        <h2 className='texEstacionamento' style={{'lineHeigth': 'normal', 'margin': '0px'}}>PLACA: <span>{estacionamento[0].placa}</span></h2>
                        <h2 className='texEstacionamento' style={{'lineHeigth': 'normal', 'margin': '0px'}}>DATA: <span>{new Date(estacionamento[0].data).toLocaleDateString('pt-BR', {timeZone: 'UTC'})}</span></h2>
                    </div>

                    </div>
                    :
                    null
                }
                </div>

        </Dialog>
    );
}
